<template>
  <div class="modal">
    <div class="modal-window bg-gray-light">
      <div>
        <div class="flex policy-title">
          <div class="text-center text-lg font-bold">
            <img src="@/assets/images/jrLogo.svg" alt="ロゴ" class="w-8" />
          </div>  
          <div class="text-center text-lg font-bold">リアルタイム経路検索
          </div>
        </div>
        <p>本サービスを利用するにあたり、<a class="break-all text-link" target="_blank" href="https://transit.jre-maas.com/terms">利用規約</a>、<a class="break-all text-link" target="_blank" href="https://transit.jre-maas.com/privacy">プライバシーポリシー</a>をご確認いただきご同意ください。</p>
        <div class="flex">
          <div class="mt-4 w-1/2">
            <a class="button-primary block" @click="acceptPolicy">
              <span class="block whitespace-nowrap text-xs">同意する</span>
            </a>
          </div>
          <div class="mt-4 w-1/2">
            <a class="bg-gray-300 px-2 py-1 border rounded-lg text-center block" @click="closePolicy">
              <span class="block whitespace-nowrap text-xs">同意しない</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {};
  },
  methods: {
    closePolicy: function () {
      this.$emit('closePolicyCheck')
    },
    acceptPolicy: function () {
      this.$emit('acceptPolicyCheck')
    }
  }
}
</script>
<style lang="scss" scoped>
.policy-title{
  align-items: center;
  justify-content: center;
}

</style>